/**
 * Modelo Padrão de Unidade Administrativa Logada.
 */
export class UnidAdm {

    unity: string;
    deUnity: string;

    constructor() { }

}